import React, { useState } from "react";
import { ToastProvider } from "./components/common/Toast";
import { Web3Provider } from "./context/Web3Context";
import { TxProvider } from "./context/TxContext";
import Navbar from "./components/layout/Navbar";
import TabNav from "./components/layout/TabNav";
import NetworkGuard from "./components/NetworkGuard";
import AccessGuard from "./components/AccessGuard";
import PurchaseAdmin from "./pages/PurchaseAdmin";
import ScnTokenAdmin from "./pages/ScnTokenAdmin";
import ScnDexAdmin from "./pages/ScnDexAdmin";
import CoreDexAdmin from "./pages/CoreDexAdmin";
import CoreTokenAdmin from "./pages/CoreTokenAdmin";
import CoreMiningAdmin from "./pages/CoreMiningAdmin";

function AdminShell() {
  const [tab, setTab] = useState("purchase");
  let page = null;
  if (tab === "purchase") page = <PurchaseAdmin />;
  else if (tab === "scntoken") page = <ScnTokenAdmin />;
  else if (tab === "scndex") page = <ScnDexAdmin />;
  else if (tab === "coredex") page = <CoreDexAdmin />;
  else if (tab === "coretoken") page = <CoreTokenAdmin />;
  else if (tab === "coremining") page = <CoreMiningAdmin />;

  return (
    <main className="app-content">
      <TabNav active={tab} onChange={setTab} />
      <div key={tab} className="page-enter">{page}</div>
    </main>
  );
}

export default function App() {
  return (
    <ToastProvider>
      <Web3Provider>
        <TxProvider>
          <div className="app-shell">
            <Navbar />
            <NetworkGuard>
              <AccessGuard>
                <AdminShell />
              </AccessGuard>
            </NetworkGuard>
          </div>
        </TxProvider>
      </Web3Provider>
    </ToastProvider>
  );
}
